export const COMPOSE = 'compose';
export const FLOATING_REPLY = 'floating-reply';
export const MOBILE_EDITOR = 'mobile-editor';
export const REPLY_EDITOR = 'reply-editor';